import { assert_false, assert_string_object_id, assert_string_object_id_not_empty } from '@shared/asserts/utils_asserts';
import { DTO__base } from '@shared/common/DTO__base';
import { ENUM__string_id_empty } from '@shared/constants/ENUM__string_id_empty';
import { MAP__serializable } from '@shared/dto/_base/MAP__serializable';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { MAP_OF_MAP__fields_store } from '@shared/types/types';
import { DTO__generation } from '../DTO__generation';
import { DTO__generation_tool } from '../DTO__generation_tool';
import { DTO_GRAPH__instance } from '../graph_invoke/_graph/DTO_GRAPH__instance';

export class DTO_REQUEST__generation_create extends DTO__base {
  /*
   * STATIC FIELDS
   */
  static _class_name_static: string = ENUM__dto_class_name.REQUEST_GENERATION_CREATE;

  /*
   *
   */
  static CREATE_FOR_CLONE(generation: DTO__generation) {
    let tool = generation.tool.clone();
    tool.generation_id = ENUM__string_id_empty.OBJECT_ID;
    tool.graph.set_graph_id(ENUM__string_id_empty.OBJECT_ID);
    tool.graph.hash_clear();

    let out = new DTO_REQUEST__generation_create();
    out.generation_id_previous = generation.previous_generation_id;
    out.tool = tool;
    out.user_task_id = generation.user_task_id;

    return out;
  }
  /*
   * FIELDS
   */
  generation_id_previous!: string;
  tool!: DTO__generation_tool;
  graph!: DTO_GRAPH__instance;
  user_task_id!: string;
  fields_store!: MAP_OF_MAP__fields_store;

  /*
   * METHODS
   */

  constructor() {
    super();

    this.tool = DTO__generation_tool.CREATE_STUB();
    this.fields_store = new MAP__serializable();
  }

  assert_standard_fields() {
    let { generation_id_previous, user_task_id } = this;

    assert_string_object_id(generation_id_previous);
    assert_string_object_id_not_empty(user_task_id);

    assert_false(this.tool.is_stub());
  }
}
